import React from 'react';
import MarketingProject from '../components/MarketingProject';

import thought from '../assets/images/thought-leadership-1.png';
import press from '../assets/images/press-release.png';
import pov from '../assets/images/thought-leadership-2.png';
import deck from '../assets/images/pitch-deck.png';
import sheet from '../assets/images/one-sheet.png';
import promotion from '../assets/images/promo-email.png';
import onboarding from '../assets/images/onboarding-email.png';
import award from '../assets/images/award-submission.png';

function MarketingPortfolio() {
  return (
    <section className="portfolio-section">
      <h3>MARKETING PROJECTS</h3>
      <div className="projects">
      <MarketingProject
          title="Thought Leadership: Media & Search in the AI Era"
          description="Synthesized industry research and SME insights into Acxiom’s point of view on how AI is reshaping media and search strategy."
          image={pov}
          projectLink="https://www.acxiom.com/resources/adapting-your-media-and-search-strategy-to-the-rise-of-ai/"
        />
      <MarketingProject
          title="Public Relations: AI Platform Messaging"
          description="Defined the marketing positioning and AI-platform narrative incorporated into Acxiom's Latin America expansion press release."
          image={press}
          projectLink="https://www.acxiom.com.mx/news/ipgs-acxiom-significantly-expands-data-and-professional-services-capabilities-across-latin-america/"
        />
      <MarketingProject
          title="Thought Leadership: AI-Driven Creative Personalization"
          description="Authored an AI-focused thought leadership article on creative personalization, published under the Product Manager’s byline."
          image={thought}
          projectLink="https://www.thedrum.com/profile/ipgmediabrands/article/ai-driven-creative-personalization-revolutionizing-brand-engagement"
        />
        <MarketingProject
          title="Pitch Deck: Meta's Conversion API"
          description="Developed a sample pitch deck translating publicly available technical details into clear, sales-ready messaging."
          image={deck}
          projectLink="https://drive.google.com/file/d/1QIbW3hd6_RsmeJlOPxmz3Hs00U3HzSN1/view?usp=sharing"
        />
        <MarketingProject
          title="One Sheet: Meta's Conversion API"
          description="Condensed complex API functionality into a concise, visually scannable one-sheet reference."
          image={sheet}
          projectLink="https://drive.google.com/file/d/1U0apl4kJ9gXwh-HGdITr4wukiG0EfXFK/view?usp=sharing"
        />
        <MarketingProject
          title="Onboarding Email Strategy: Warmly AI Intent Platform"
          description="Recommended an onboarding email strategy to increase setup completion and promote premium feature adoption."
          image={onboarding}
          projectLink="https://drive.google.com/file/d/19a99T1jUNdFFJy71YiwQUTTwNT1qAa4X/view"
        />
        <MarketingProject
          title="Promotional Email: Daybreaker Carnival Event"
          description="Crafted a high-energy promotional email designed to drive excitement and ticket sales."
          image={promotion}
          projectLink="https://drive.google.com/file/d/1zox6XvR-rkKOisygSLWAi61BzGpKZnnB/view"
        />
        <MarketingProject
          title="Awards Submission: Digiday AI Leader of the Year"
          description="Prepared and submitted the award entry that helped secure “AI Leader of the Year” recognition in the 2025 Digiday AI Awards."
          image={award}
          projectLink="https://digiday.com/announcement/canva-bloomberg-media-studios-and-vidmob-are-among-winners-of-the-2025-digiday-ai-awards/"
        />
      </div>
    </section>
  );
}

export default MarketingPortfolio;